// libs
import React from 'react';
import PropTypes from 'prop-types';

// enhancers
import { tileEnhancer } from '@biw/dashboard';
//components
import ManagerOverviewTile from './tiles/manager/manager-overview';
import ManagerGoalSelectionTile from './tiles/manager/manager-goal-selection';
import ManagerProgressTile from './tiles/manager/manager-progress';
import ManagerNoProgressTile from './tiles/manager/manager-no-progress';
import ManagerFinalResultTile from './tiles/manager/manager-final-result';
import ProgramOverviewTile from './tiles/participant/program-overview';
import GoalSelectedTile from './tiles/participant/goal-selected';
import NoGoalSelectedTile from './tiles/participant/no-goal-selected';
import NoProgressTile from './tiles/participant/no-progress';
import ProgressTile from './tiles/participant/progress';
import WaitingForFinalResultTile from './tiles/participant/wating-for-final-result';
import FinalResultTile from './tiles/participant/final-result';

import './tile.scss';

function getTileForType( tileType ) {
    switch ( tileType ) {
        case 'manager-overview':
            return ManagerOverviewTile;
        case 'manager-goal-selection':
            return ManagerGoalSelectionTile;
        case 'manager-no-progress':
            return ManagerNoProgressTile;
        case 'manager-progress':
            return ManagerProgressTile;
        case 'manager-final-result':
            return ManagerFinalResultTile;
        case 'program-overview':
            return ProgramOverviewTile;
        case 'goal-selected':
            return GoalSelectedTile;
        case 'no-goal-selected':
            return NoGoalSelectedTile;
        case 'no-progress':
            return NoProgressTile;
        case 'progress':
            return ProgressTile;
        case 'waiting-for-final-result':
            return WaitingForFinalResultTile;
        case 'final-result':
            return FinalResultTile;
        default:
            return ProgramOverviewTile;
    }
}

export class Tile extends React.Component {
    static propTypes = {
        tileType: PropTypes.string,
        programViewId: PropTypes.string.isRequired
    }

    render() {
        const { tileType } = this.props;
        const ContentTile = getTileForType( tileType );
        return (

            <div className="dashboard-list-item">
                <ContentTile { ...this.props } />
            </div>
        );
    }
}

export default tileEnhancer( Tile );
